import { observable } from 'mobx'
import { v4 as uuidv4 } from 'uuid'
import * as R from 'ramda'

class SubQuestion {
    id = uuidv4()

    kind = 'SubQuestion'

    @observable pageQuestionId

    ranking

    removeBaseLimit

    constructor({
        pageQuestionId,
        ranking = 'noRanking',
        removeBaseLimit,
    }) {
        this.pageQuestionId = pageQuestionId
        this.ranking = ranking
        this.removeBaseLimit = removeBaseLimit
    }

    static clone(subQuestion) {
        return new SubQuestion({
            pageQuestionId: subQuestion.pageQuestionId,
            ranking: subQuestion.ranking,
            removeBaseLimit: subQuestion.removeBaseLimit,
        })
    }

    toJSON() {
        return {
            pageQuestionId: this.pageQuestionId,
            ranking: this.ranking,
            removeBaseLimit: !R.isNil(this.removeBaseLimit)
                ? parseInt(this.removeBaseLimit, 10)
                : undefined,
        }
    }
}

export default SubQuestion
